import { mapActions, mapState } from 'vuex'
import { api } from '@/plugins/api'

export default {
  data () {
    return {
      makingOrder: false,
      orderMode: false,
      order: null,
      shopModal: null,
      shopModalKind: null,
      orderCreated: false,
      tab: 0,
      orderHeaders: [
        { text: 'Nazwa', value: 'name' },
        { text: 'Ilość', value: 'quantity' },
        { text: 'Wariant', value: 'variant' },
        { text: 'Kwota', value: 'price' }
      ],
      orderHistoryHeaders: [
        { text: 'Data', value: 'date' },
        { text: 'Nazwa', value: 'name' },
        { text: 'Ilość', value: 'quantity' },
        { text: 'Wariant', value: 'variant' },
        { text: 'Kwota', value: 'price' }
      ]
    }
  },
  computed: {
    ...mapState(['shopItems', 'shopOrders']),
    cap () {
      return this.shopOrders.reduce((res, order) => {
        if (!res[order.itemId]) {
          res[order.itemId] = 0
        }
        res[order.itemId] -= order.quantity
        return res
      }, this.shopItems.reduce((res, item) => {
        res[item.id] = item.cap
        return res
      }, {}))
    },
    price () {
      return this.order
        ? Object.keys(this.order).reduce((price, itemId) => {
          return price + (this.order[itemId].quantity || 0) * this.shopItems.find(i => i.id === itemId).price
        }, 0)
        : 0
    },
    canBuy () {
      return this.price && !this.shopItems.find(item => item.variants && this.order[item.id].quantity && !this.order[item.id].variant)
    },
    orderItems () {
      return this.order
        ? Object.keys(this.order).reduce((items, itemId, index) => {
          items.push({
            id: itemId,
            name: this.shopItems.find(i => i.id === itemId).name,
            quantity: (this.order[itemId].quantity || 0),
            variant: this.order[itemId].variant || '',
            price: (this.order[itemId].quantity || 0) * this.shopItems.find(i => i.id === itemId).price
          })
          return items
        }, []).filter(item => item.quantity)
        : []
    },
    orderHistoryItems () {
      return this.shopOrders.map(o => ({
        ...o.item,
        ...o,
        price: o.quantity * o.item.price,
        date: new Date(o.createdAt).toLocaleString()
      }))
    },
    modalItem () {
      return this.shopModalKind ? this.shopItems.find(i => i.id === this.shopModalKind) : null
    },
    modalItemImages () {
      return this.modalItem ? [this.shopModalKind, ...(this.modalItem.images || [])] : []
    }
  },
  watch: {
    shopItems: {
      handler: function (items) {
        if (items && items.length && this.order === null) {
          this.order = this.shopItems.reduce((res, item) => {
            res[item.id] = { quantity: 0, variant: null }
            return res
          }, {})
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['loadData']),
    makeOrder () {
      this.makingOrder = true
      api.makeOrder({
        order: this.orderItems
      }).then(_ => {
        this.loadData().then(() => {
          this.order = this.shopItems.reduce((res, item) => {
            res[item.id] = { quantity: 0, variant: null }
            return res
          }, {})
          this.orderCreated = true
          this.makingOrder = false
          this.orderMode = false
        })
      }).catch(_ => {
        this.makingOrder = false
        this.orderMode = false
      })
    }
  }
}
